import {ProductType} from "@/constants/productTypes";

function apiBase() {
  switch (process.env.VUE_APP_ENV) {
    case 'production' :
      return 'https://api.sensefly.io/v1';
    case 'staging' :
      return 'https://staging.sensefly.io/v1';
    case 'test' :
      return 'https://test.sensefly.io/v1';
    default:
      throw new Error(`Unsupported VUE_APP_ENV: ${process.env.VUE_APP_ENV}`);
  }
}

export const API_BASE = apiBase();

export const API_INVITATION_URL = (key: string) => `${API_BASE}/users/product-registrations/${key}`;

export const API_USER_URL = `${API_BASE}/users/me`;

export const API_GET_PRODUCT_HISTORY_URL = (productUuid: string) => `${API_BASE}/products/${productUuid}/rmas?status=closed&pageSize=100`;

export const API_CUSTOMER_URL = (uuid: string) => `${API_BASE}/customers/${uuid}`;

export const API_GET_PRODUCTS_URL = (customerUuid: string, productType: ProductType) => `${API_CUSTOMER_URL(customerUuid)}/products?category=${productType.name}&pageSize=2000`;

export const API_ACTIVATE_PRODUCT_URL = (productUuid: string) => `${API_BASE}/products/${productUuid}/activations`;

export const API_GET_SOFTWARE_URL = (productId: string) => `${API_BASE}/products/software/${productId}`;

export const API_GET_PRODUCT_CONTRACTS_URL = (productUuid: string) => `${API_BASE}/contracts?productUuid=${productUuid}&pageSize=100`;

export const API_USER_SUBSCRIPTIONS_URL = `${API_BASE}/users/me/subscriptions`;



// WEBPACK FOOTER //
// ./src/constants/api.ts